import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { EyeFill, EyeSlash } from 'react-bootstrap-icons'; 
import RecuperarContraseñaModal from '../components/RecuperarPassword';
import '../styles/login.css';
import { api, rawAxios } from '../api';

const LoginPage = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showRecuperarModal, setShowRecuperarModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const isAuthenticated = localStorage.getItem('auth') === 'true';
    if (isAuthenticated) {
      navigate('/salas');
    }
  }, [navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setLoading(true);

    try {
      // await axios.get('/sanctum/csrf-cookie'); // importante para CSRF token
      // const response = await axios.post('/login', form);

      await rawAxios.get('/sanctum/csrf-cookie');
      const response = await rawAxios.post('/login', form, {
        headers: { Accept: 'application/json' },
      });

      localStorage.setItem('auth', 'true');
      localStorage.setItem('role', response.data.user.role);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      navigate('/salas');
    } catch (err) {
      if (err.response?.status === 422) {
        setErrors(err.response.data.errors);
      } else {
        alert('Error al iniciar sesión');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{ position: 'relative' }}>
        <div className="row">
          <div className="col-sm-6 left-div" style={{ backgroundColor: '#355d91' }}>
            <div className="left-inside-div h-custom-2">
              <form onSubmit={handleSubmit} className='form-login'>
                <h3
                  className="mb-4"
                  style={{
                    color: 'white',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '25px',
                  }}
                >
                  Iniciar Sesión
                </h3>
                <div className="mb-3">
                  <input
                    type="email"
                    name="email"
                    className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                    placeholder='Correo electrónico'
                    value={form.email}
                    onChange={handleChange}
                    required
                  />
                  {errors.email && <div className="invalid-feedback">{errors.email[0]}</div>}
                </div>
                <div className="mb-3">
                  <div style={{ position: 'relative' }}>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                      placeholder='Contraseña'
                      value={form.password}
                      onChange={handleChange}
                      required
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: 'absolute',
                        right: '0.75rem',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 0,
                      }}
                      aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                    >
                      {showPassword ? (
                        <EyeSlash style={{ width: '1.25rem', height: '1.25rem', color: '#6a6e73' }} />
                      ) : (
                        <EyeFill style={{ width: '1.25rem', height: '1.25rem', color: '#6a6e73' }} />
                      )}
                    </button>
                  </div>
                  
                  {errors.password && <div className="invalid-feedback">{errors.password[0]}</div>}
                </div>
                <button type="submit" className="w-50 button-login" disabled={loading}>
                  {loading ? 'Ingresando...' : 'Ingresar'}
                </button>
                <div className="mt-3 text-center">
                  <a href="#" style={{ color: 'white' }} className='res_pass' onClick={() => setShowRecuperarModal(true)}>¿Olvidaste tu contraseña?</a>
                </div>
              </form>
            </div>
          </div>
          <div className="right-div d-sm-block col-sm-6">
            <div className="right-inside-div" style={{ height: '100%' }}>
              <img
                src="/assets/Logo_SITE_Turnos_horizontal.png"
                alt="Login"
                className="w-50 img-fluid"
                style={{ objectFit: 'cover', objectPosition: 'left' }}
              />
            </div>
          </div>
        </div>
      </div>
      <RecuperarContraseñaModal show={showRecuperarModal} onClose={() => setShowRecuperarModal(false)} />
    </>
  );
};

export default LoginPage;
